export default "__VITE_ASSET__DEVA7ePP__"